import { render } from "./Cronogram.vue?vue&type=template&id=1956f0df&scoped=true"
import script from "./Cronogram.vue?vue&type=script&lang=js"
export * from "./Cronogram.vue?vue&type=script&lang=js"

import "./Cronogram.vue?vue&type=style&index=0&id=1956f0df&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1956f0df"

export default script